
import React, { useState, useRef, useEffect } from 'react';
import { Tabs, TabList, TabPanels, Tab, TabPanel } from '@chakra-ui/react'
import { Avatar, Stack } from '@chakra-ui/react'
import { Mail, MessageCircle, Handshake, Newspaper, Search } from 'lucide-react';
import WhatsApp from '../../../utils/communications/whatsapp/WhatsApp.js';
import Chat from '../../../utils/communications/chat/Chat.js';
import Email from '../../../utils/communications/email/Email.js';
import Notes from '../../../utils/notes/Notes.js';
import Attachment from '../../inspection/Attachments.js';
import { useLocation } from 'react-router-dom';
import {getlistByIdnearMiss} from '../../../redux/api/healthSaftyApi/HealthSaftyNearMiss.js';


export default function PpayrollDetail() {
    const location = useLocation();
    const id = location.state?.ROWID || "";
    const [item, setitem] = useState(null);
    useEffect(() => {
       console.log(location)
        console.log({ id })
        

        getlistByIdnearMiss(id).then((response) => {
            if (response.data.success ) {
                setitem(response.data.nearMiss[0]);
            }
        }).catch((error) => {
            console.log({ error });
        });
    }, [id]);

    useEffect(() => {
        console.log({ item })
    }, [item])

    //for adding scrollbar in tablist
    const tabListRef = useRef(null);
    const [touchStartX, setTouchStartX] = useState(0);
    const [touchEndX, setTouchEndX] = useState(0);
    const [isOpen, setIsOpen] = useState(false);

    const toggleDropdown = () => setIsOpen(prevState => !prevState);

    const handleTouchStart = (e) => {
        setTouchStartX(e.touches[0].itemX);
    };

    const handleTouchMove = (e) => {
        setTouchEndX(e.touches[0].itemX);
    };

    const handleTouchEnd = () => {
        if (tabListRef.current) {
            const distance = touchStartX - touchEndX;

            if (distance > 50) {
                // Swipe left to scroll right
                tabListRef.current.scrollBy({ left: 100, behavior: 'smooth' });
            } else if (distance < -50) {
                // Swipe right to scroll left
                tabListRef.current.scrollBy({ left: -100, behavior: 'smooth' });
            }
        }
    };

   
 

//   const location = useLocation();
//   const id = location.state?.ROWID || "";
//   const [item, setitem] = useState(null);
//   useEffect(() => {
//      console.log(location)
//       console.log({ id })
      

//       getlistByIdnearMiss(id).then((response) => {
//           if (response.data.success ) {
//               setitem(response.data.nearMissResp[0]);
//           }
//       }).catch((error) => {
//           console.log({ error });
//       });
//   }, [id]);

//   useEffect(() => {
//       console.log({ item })
//   }, [item])

//   //for adding scrollbar in tablist
//   const tabListRef = useRef(null);
//   const [touchStartX, setTouchStartX] = useState(0);
//   const [touchEndX, setTouchEndX] = useState(0);
//   const [isOpen, setIsOpen] = useState(false);

//   const toggleDropdown = () => setIsOpen(prevState => !prevState);

//   const handleTouchStart = (e) => {
//       setTouchStartX(e.touches[0].itemX);
//   };

//   const handleTouchMove = (e) => {
//       setTouchEndX(e.touches[0].itemX);
//   };

//   const handleTouchEnd = () => {
//       if (tabListRef.current) {
//           const distance = touchStartX - touchEndX;

//           if (distance > 50) {
//               // Swipe left to scroll right
//               tabListRef.current.scrollBy({ left: 100, behavior: 'smooth' });
//           } else if (distance < -50) {
//               // Swipe right to scroll left
//               tabListRef.current.scrollBy({ left: -100, behavior: 'smooth' });
//           }
//       }
//   };
  


    return (
        <div className='custom-scroll' style={{ minHeight: '88vh' }}>
            <Tabs variant='enclosed'>
                <TabList  ref={tabListRef} className="custom-tablist" onTouchStart={handleTouchStart} onTouchMove={handleTouchMove} onTouchEnd={handleTouchEnd}>
                    <Tab>Overview</Tab>
                    <Tab>Notes</Tab>
                    <Tab>Attachments</Tab>
                    <Tab>Comms</Tab>
                </TabList>
                <TabPanels>
                    {/* Overview panel */}
                    <TabPanel >
                        <div>
                            {/* Profile div  */}
                            <div className='wrapper card card-detail mt-3'>
                                <div className='d-flex ' >
                                    <div className='col-lg-2 col-md-12 align-items-center justify-content-center mt-3' style={{ width: '7rem' }}>
                                        <Stack direction='row' >
                                            <Avatar size='xl' name='Prosper Otemuyiwa' src='https://i.imgur.com/uTSyI4q.jpeg' />
                                        </Stack>
                                    </div>
                                    <div className='col-lg-6 col-md-12 mt-4'>
                                        <h4 style={{ color: "#023233" }}>{item?.firstName || 'NA'}</h4>
                                        <p>NearMiss</p>
                                    </div>
                                    <div className='col-lg-4 col-md-12  mt-3'>
                                        <div className='d-flex gap-3 mt-3'>
                                            <Mail color='#ff176b' strokeWidth="1" />
                                            <MessageCircle color='#ff176b' strokeWidth="1" />
                                            <Handshake color='#ff176b' strokeWidth="1" />
                                            <Newspaper color='#ff176b' strokeWidth="1" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* Profile div  end */}
                            {/* Below content  */}
                            <h6 style={{ color: "#767272", marginLeft: "10px" }}>Near-Miss</h6>
                            <div class="wrapper mt-1">
                                <div class="row g-3">
                                    <div class="col-lg-6 col-md-12 align-items-stretch">
                                        <div class="card card-detail p-0">
                                            <div class="card-body py-0 pe-0">
                                                <div class="table-responsive table-div1">
                                                    <table class="table table-space ">
                                                        <tr className='tr-border'>
                                                            <th className='font-weight table-space'>First Name</th>
                                                            <td className='font-color'>{item?.firstName || 'NA'}</td>
                                                        </tr>
                                                        <tr className='tr-border'>
                                                            <th className='font-weight table-space'>Last Name</th>
                                                            <td className='font-color'>{item?.lastName || 'NA'}</td>
                                                        </tr>
                                                        <tr className='tr-border'>
                                                            <th className='font-weight table-space'>Date & Time Of Near Miss</th>
                                                            <td className='font-color'>{item?.dateTimeOfNearMiss || 'NA'}</td>
                                                        </tr>
                                                        <tr className='tr-border'>
                                                            <th className='font-weight table-space'>Location Of The Near Miss</th>
                                                            <td className='font-color'>	{item?.lcationOfTheNearMiss || 'NA'}</td>
                                                        </tr>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <h6 style={{ color: "#767272", marginLeft:"10px"}}>Witness Information</h6>
                                <div class="row g-3">
                                    <div class="col-lg-6 col-md-12 align-items-stretch">
                                        <div class="card card-detail p-0">
                                            <div class="card-body py-0 pe-0">
                                                <div class="table-responsive table-div1">
                                                    <table class="table table-space ">
                                                    <tr className='tr-border'>
                                                            <th className='font-weight table-space'>Witness First Name</th>
                                                            <td className='font-color'>	{item?.first_Name || 'NA'}</td>
                                                        </tr>
                                                        <tr className='tr-border'>
                                                            <th className='font-weight table-space'>Witness Last Name</th>
                                                            <td className='font-color'>{item?.last_Name || 'NA'}</td>
                                                        </tr>
                                                        <tr className='tr-border'>
                                                            <th className='font-weight table-space'>Email</th>
                                                            <td className='font-color'>{item?.email || 'NA'}</td>
                                                        </tr>
                                                        <tr className='tr-border'>
                                                            <th className='font-weight table-space'>Phone Number</th>
                                                            <td className='font-color'>{item?.phoneNumber || 'NA'}</td>
                                                        </tr>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <h6 style={{ color: "#767272", marginLeft: "10px", marginTop: "10px" }}>Describe the Near-Miss including any events leading to or immediately following the near-miss.</h6>
                                <div className='row g-3'>
                                    <div className="col-lg-12 col-md-12">
                                        <div className="card card-detail p-4">
                                            <div className="card-body py-0 pe-0">
                                                <div className='tr-border'>{item?.describeTheNearMiss || 'NA'}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <h6 style={{ color: "#767272", marginLeft: "10px", marginTop: "10px" }}>Describe how the incident could potentially result in a serious or life-threatning situtaion?</h6>
                                <div className='row g-3'>
                                    <div className="col-lg-12 col-md-12">
                                        <div className="card card-detail p-4">
                                            <div className="card-body py-0 pe-0">
                                                <div className='tr-border'>{item?.describeHowTheIncident || 'NA'}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <h6 style={{ color: "#767272", marginLeft: "10px", marginTop: "10px" }}>Please indicate how the incident can be prevented from reoccuring again:</h6>
                                <div className='row g-3'>
                                    <div className="col-lg-12 col-md-12">
                                        <div className="card card-detail p-4">
                                            <div className="card-body py-0 pe-0">
                                                <div className='tr-border'>{item?.pleaseIndicateHow || 'NA'}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <h6 style={{ color: "#767272", marginLeft: "10px", marginTop: "10px" }}>Please provide any other comments below:</h6>
                                <div className='row g-3'>
                                    <div className="col-lg-12 col-md-12">
                                        <div className="card card-detail p-4">
                                            <div className="card-body py-0 pe-0">
                                                <div className='tr-border'>{item?.pleaseProvideAnyOtherComments || 'NA'}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </TabPanel>
                    {/* Overview panel ends*/}
                    {/* notes panel  */}
                    <TabPanel className='pt-0'>
                        <Notes module={"nearMiss"} id={id} />
                    </TabPanel>
                    {/* notes panel ends */}
                    <TabPanel>
                        <Attachment />
                    </TabPanel>
                    {/* tab panel for comms */}
                    <TabPanel>
                        <div className='w-100 d-flex justify-content-between align-items-center'>
                            <section>
                                <div className=' popup-search d-flex align-items-center mb-3 bg-white'>
                                    <Search size="18px" /> <input type='search' className='ms-2' style={{ outline: "none", border: "none" }} placeholder='Search' />
                                </div>
                            </section>
                            <section>
                            </section>
                        </div>
                        {/* tabs for subnav */}
                        <Tabs size='sm' variant='enclosed'>
                            <TabList>
                                <Tab>WhatsApp</Tab>
                                <Tab>SMS</Tab>
                                <Tab>Email</Tab>
                            </TabList>
                            <TabPanels>
                                <TabPanel className='custom-scroll '>
                                    <WhatsApp />
                                </TabPanel>
                                <TabPanel className='custom-scroll '>
                                    <Chat />
                                </TabPanel>
                                <TabPanel className='custom-scroll '>
                                    <Email />
                                </TabPanel>
                            </TabPanels>
                        </Tabs>
                        {/* tabs for subnav ends */}
                    </TabPanel>
                    {/* tab panel for comms ends*/}
                </TabPanels>



            </Tabs>
        </div>
    )
}
